import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { Button } from 'reactstrap'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'
import { renderField } from '../../../utilities/reduxForm.util'
import { required, emailValidator } from '../../../utilities/validators'
import SupportModal from '../../Modal/SupportModal/SupportModal'
import FaqAccordion from '../../Faq/FaqAccordion'
import Loader from '../../Loader/Loader'

import './SupportForm.scss'

const validate = value => {
  const errors = {}
  if (value.supportQuestionType === '0') {
    errors.supportQuestionType = 'global.label.requiredField'
  }
  return errors
}

class SupportForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
      error: false,
      submitting: false,
      userQuestion: '',
    }
  }

  componentDidMount() {
    const { user } = this.props
    if (user) {
      this.handleInitialize()
    }
  }

  handleOnChange = e => {
    this.setState({
      userQuestion: e.target.value,
    })
  }

  handleInitialize() {
    const { user, initialize } = this.props
    const initData = {
      supportName: user && user.firstname,
      supportEmail: user && user.email,
    }
    initialize(initData)
  }

  submitMaster = values => {
    const { submitting } = this.state

    if (submitting) {
      return
    }

    const { onSubmit, reset } = this.props

    this.setState({ submitting: true })

    return onSubmit(values)
      .then(() => {
        this.setState({ error: false })
      })
      .catch(() => {
        this.setState({ error: true })
      })
      .finally(() => {
        this.setState(state => ({
          modalOpen: !state.modalOpen,
          submitting: false,
        }))
        reset()
      })
  }

  _toggleModal = () => {
    this.setState(state => ({
      modalOpen: !state.modalOpen,
    }))
  }

  renderFaqAccordian = () => {
    const { supportLoading, supportContent } = this.props
    const { userQuestion } = this.state

    const mappedSuggestion = supportContent
      .map((faq, index) => {
        let check = false
        Object.values(faq).forEach(s => {
          if (typeof s === 'string' && userQuestion !== undefined) {
            check = userQuestion.toLowerCase().includes(s.toLowerCase())
          }
          return check
        })
        return check ? supportContent[index] : null
      })
      .filter(v => v !== null)
    const supportSuggestions = mappedSuggestion.reduce((unique, o) => {
      if (!unique.some(obj => obj.question === o.question)) {
        unique.push(o)
      }
      return unique
    }, [])

    return (
      <div className="mt-4" role="region" aria-labelledby="faq-suggestions-title">
        <div id="faq-suggestions-title" className="sr-only">
          FAQ suggestions based on your question
        </div>
        {supportLoading ? (
          <Loader aria-label="Loading FAQ suggestions" />
        ) : (
          <FaqAccordion faqs={supportSuggestions} />
        )}
      </div>
    )
  }

  render() {
    const { handleSubmit } = this.props
    const { modalOpen, error, submitting, userQuestion } = this.state

    return (
      <form
        onSubmit={handleSubmit(this.submitMaster.bind(this))}
        method="post"
        aria-labelledby="support-form-title"
      >
        <div id="support-form-title" className="sr-only">
          Support request form
        </div>
        <SupportModal isOpen={modalOpen} toggle={this._toggleModal} error={error} />
        <div disabled={false}>
          <div className="sr-only">Customer support form</div>
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <Field
                  component={renderField}
                  validate={[required]}
                  inputType="input"
                  type="text"
                  containerclass="col form-group"
                  name="supportName"
                  aria-describedby="supportName"
                  label="global.label.yourName"
                />
              </div>
              <div className="row">
                <Field
                  component={renderField}
                  validate={[required, emailValidator]}
                  inputType="input"
                  type="email"
                  containerclass="col form-group"
                  name="supportEmail"
                  aria-describedby="supportEmail"
                  label="global.label.yourEmail"
                />
              </div>
              <div className="row">
                <Field
                  component={renderField}
                  inputType="select"
                  validate={[required]}
                  label="global.label.questionType"
                  containerclass="col form-group"
                  name="supportQuestionType"
                  aria-describedby="supportQuestionType"
                  options={[
                    { value: 0, key: 'page.supportPage.question.type' },
                    {
                      value: 1,
                      key: 'page.supportPage.question.accountRegistration',
                    },
                    { value: 2, key: 'page.supportPage.question.coupon' },
                    { value: 3, key: 'page.supportPage.question.pvt' },
                    { value: 4, key: 'page.supportPage.question.other' },
                  ]}
                />
              </div>
              <div className="row">
                <Field
                  component={renderField}
                  inputType="input"
                  type="text"
                  containerclass="col form-group"
                  name="supportCouponCode"
                  aria-describedby="supportCouponCode"
                  label="global.label.yourCouponCode"
                />
              </div>
              <div className="row">
                <Field
                  component={renderField}
                  validate={[required]}
                  inputType="textarea"
                  onChange={this.handleOnChange}
                  type="text"
                  containerclass="col"
                  name="supportQuestion"
                  aria-describedby="supportQuestion faq-suggestions-help"
                  label="global.label.yourQuestion"
                />
                <div id="faq-suggestions-help" className="sr-only">
                  As you type your question, relevant FAQ suggestions will appear below
                </div>
              </div>
              <div className="row">
                <Button
                  name="supportFormSubmitBtn"
                  type="submit"
                  outline
                  color="dark"
                  className="mt-5 ml-3 mr-3"
                  block
                  disabled={submitting}
                  aria-describedby="support-form-title"
                  aria-busy={submitting}
                >
                  {submitting ? <Loader noBorder /> : <FormattedMessage id="global.label.submit" />}
                </Button>
              </div>
            </div>
            <div className="col-md-4">
              <Field
                component={renderField}
                inputType="fileupload"
                type="file"
                name="supportFiles"
                aria-describedby="supportFiles"
                containerclass="h-100"
              />
            </div>
          </div>
          {userQuestion.length > 0 ? this.renderFaqAccordian() : null}
        </div>
      </form>
    )
  }
}

export default reduxForm({
  form: 'supportForm',
  validate,
})(SupportForm)
